import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLineModule } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConditionSetsListComponent } from './condition-sets-list.component';

@NgModule({
  declarations: [
    ConditionSetsListComponent
  ],
  imports: [
    CommonModule,
    MatListModule,
    MatLineModule,
    MatTooltipModule
  ],
  exports: [
    ConditionSetsListComponent
  ]
})
export class ConditionSetsListModule { }
